import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const PreloaderPage = () => {

  return (
    <div className="app mainPage">
         <div className="screenPageBody centerItem blueInner" style={{ height: '100vh' }}>
            Loading...
         </div>
    </div>
    )
}

export default PreloaderPage